const footerObj = {
  phone: "+905338544310",
  twitter: "Twitter",
  twitterAddress: "https://twitter.com/marieevene",
  linkedin: "https://www.linkedin.com/in/yvesarthur/",
  facebook: "Facebook",
  facebookAddress: "https://www.facebook.com/kisshotacerolaorionheartunderb",
  youtube: "YouTube",
  emailMe: "Send Email",
  emailAddress:"mailto:kapayastudio@protonmail.com",
  made: "© 2022 Kapaya Studio Design — Site made by Yves Arthur",
  about: "About Me"

};
  
  export default footerObj;